var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-multiselect',{attrs:{"options":_vm.options,"value":_vm.value,"placeholder":"業種を選択してください","multiple":"","label":"name","track-by":"id"},on:{"input":_vm.input}})}
var staticRenderFns = []

export { render, staticRenderFns }